export default "__VITE_ASSET__CDbHvScD__"